export default __webpack_public_path__ + "static/media/Nico-Uchitel.cd828f6a.png";